import { fontList } from '../../core/font-list';
import { colorListPairs } from '../../core/color-list';

export let params = {
  'category': 'animation',
  'parameters': {
    'size': {
      'default': {
        'key': '600 x 600',
        'value': [600, 600],
        'label': '600 x 600'
      },
      'label': 'Afmeting',
      'type': 'array',
      'values': [
        {
          'key': '1500 x 1500',
          'value': [1500, 1500],
          'label': '1500 x 1500'
        },
        {
          'key': '1200 x 1200',
          'value': [1200, 1200],
          'label': '1200 x 1200'
        },
        {
          'key': '900 x 900',
          'value': [900, 900],
          'label': '900 x 900'
        },
        {
          'key': '600 x 600',
          'value': [600, 600],
          'label': '600 x 600'
        },
        {
          'key': '400 x 400',
          'value': [400, 400],
          'label': '400 x 400'
        },
        {
          'key': '300 x 300',
          'value': [300, 300],
          'label': '300 x 300'
        },
      ],
      'control': 'standard-select',
      'description': 'Afmeting van de visualisatie',
    },
    'animationType': {
      'default': {
        'key': 'bounce',
        'value': 'bounce',
        'label': 'Stuiter'
      },
      'label': 'Animatie',
      'type': 'string',
      'values': [
        {
          'key': 'bounce',
          'value': 'bounce',
          'label': 'Stuiter'
        },
        {
          'key': 'zoom',
          'value': 'zoom',
          'label': 'Zoom'
        },
        {
          'key': 'slideIn',
          'value': 'slideIn',
          'label': 'Schuif in'
        },
        {
          'key': 'slideOut',
          'value': 'slideOut',
          'label': 'Schuif uit'
        },
      ],
      'control': 'standard-select',
      'description': 'Animatie van de circel',
    },
    'width': {
      'default': 600,
      'label': 'Breedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'height': {
      'default': 600,
      'label': 'Hoogte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'colorScheme': {
      'default': colorListPairs[4],
      'control': 'cbs-color-scheme',
    },
    'circleColorScheme': {
      'default': colorListPairs[1],
      'control': 'cbs-color-scheme',
      'description': 'Kleur van de circel',
    },
    'offsetX': {
      'default': 300,
      'label': 'Afstand X',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Afstand t.o.v. de linkerkant',
    },
    'offsetY': {
      'default': 350,
      'label': 'Afstand Y',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Afstand t.o.v. de bovenkant',
    },
    'circleSize': {
      'default': 20,
      'label': 'Radius circle',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Groote van de circle',
    },
    'marginLeft': {
      'default': 20,
      'label': 'Linkermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginRight': {
      'default': 40,
      'label': 'Rechtermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginTop': {
      'default': 40,
      'label': 'Bovenmarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginBottom': {
      'default': 80,
      'label': 'Ondermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'formatLocale': {
      'default': {
        'key': 'nl-nl',
        'value': 'nl-nl',
        'label': 'Nederlands'
      },
      'label': 'Taal',
      'type': 'string',
      'values' : [
        {
          'key': 'nl-nl',
          'value': 'nl-nl',
          'label': 'Nederlands'
        },
        {
          'key': 'en-gb',
          'value': 'en-gb',
          'label': 'Engels'
        }
      ],
      'control': 'standard-select',
      'description': 'Taal voor het formatteren van de Y-as labels',
    },
  },
  'timings': {
    'templateAnimation': {
      'default': 1,
      'label': 'Scene 1',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'pauseEnd': {
      'default': 2,
      'label': 'Pause aan het einde',
      'type': 'numeric',
      'control': 'standard-number'
    }
  },
  'data': {
    'values': [[0.86]],
    'columnLimitMin': 1,
    'columnLimitMax': 1,
    'columnLabelNumber': 0,
    'rowLimitMin': 1,
    'rowLimitMax': 5,
    'rowLabelNumber': 0,
  },
  'parameterGroups': [
    {
      'title': 'Primair',
      'collapsed': false,
      'keys': ['size', 'colorScheme', 'offsetX', 'offsetY', 'animationType'],
    },
    {
      'title': 'Secundair',
      'collapsed': true,
      'keys': ['circleSize', 'circleColorScheme'],
    }
  ],
  'timingGroups': [
    {
      'title': 'Timing',
      'collapsed': true,
      'keys': ['templateAnimation']
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/animations/template/social.params.ts